function zeroFill(number, width) {
  width -= number.toString().length;
  if (width > 0) {
    return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
  }
  return number + ""; // always return a string
}

jQuery(document).ready(() => {

  const $testimonialsSlick = jQuery('.testimonials-slick');

  if ($testimonialsSlick.length) {
    const arrowSvg = '<svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path></g></svg>';
    const $testimonialsPaging = jQuery('.testimonials-paging');

    $testimonialsSlick.on('init reInit afterChange', (event, slick, currentSlide) => {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $testimonialsPaging.text(zeroFill(i, 2) + '/' + zeroFill(slick.slideCount, 2));
    });

    $testimonialsSlick.slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">' + arrowSvg + '</button>',
      nextArrow: '<button type="button" class="slick-next">' + arrowSvg + '</button>',
      appendArrows: jQuery('.testimonials-arrows-wrapper'),
    });
  }

  const $projectGallerySlick = jQuery('.project-gallery-slick');

  if ($projectGallerySlick.length) {
    const arrowSvg = '<svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><g fill="none" stroke="#fff" stroke-width="1.5" stroke-linejoin="round" stroke-miterlimit="10"><circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle><path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path></g></svg>';
    const $projectGalleryPaging = jQuery('.project-gallery-paging');

    $projectGallerySlick.on('init reInit afterChange', (event, slick, currentSlide) => {
      const i = (currentSlide ? currentSlide : 0) + 1;
      $projectGalleryPaging.text(zeroFill(i, 2) + '/' + zeroFill(slick.slideCount, 2));
    });

    $projectGallerySlick.slick({
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev">' + arrowSvg + '</button>',
      nextArrow: '<button type="button" class="slick-next">' + arrowSvg + '</button>',
      appendArrows: jQuery('.project-gallery-arrows-wrapper'),
    });
  }

});